import ComingSoon from '../../pages/comingsoon/comingSoon'
import HelpRootPage from '../../pages/help/root/HelpRootPage'
import NotificationsRootPage from '../../pages/notifications/NotificationsRootPage'
import MessagesPage from '../../pages/messages/MessagesPage'
/**
 * @TODO todo
 */
const IMPORTS = {
  PAGES: {
    HELP_PAGE: HelpRootPage,
    COMING_SOON: ComingSoon,
    NOTIFICATION_PAGE: NotificationsRootPage,
    MESSAGES: MessagesPage,
  },
}

export default IMPORTS
